module.exports = __webpack_public_path__ + "images/Claims_SS_568119211_e695f32.jpg";